import React, { useState } from "react";
import { Cpu, ExternalLink, Copy, CheckCircle, Zap, FileText } from "lucide-react";
import "./GFSDocs.css";

const GFSV2Docs = () => {
  const [copied, setCopied] = useState(false);

  const getDocsUrl = () => {
    if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") {
      return "http://localhost:5001/api/extraction/gfs/v2/docs";
    }
    return `${window.location.protocol}//${window.location.hostname}/api/extraction/gfs/v2/docs`;
  };

  const getApiKeyFromStorage = () => {
    try {
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      return user.api_key || "";
    } catch {
      return "";
    }
  };

  const copyApiKey = () => {
    const apiKey = getApiKeyFromStorage();
    if (apiKey) {
      navigator.clipboard.writeText(apiKey);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  return (
    <div className="gfs-docs-page">
      {/* Header Banner */}
      <div className="gfs-docs-header v2">
        <div className="gfs-docs-header-content">
          <div className="gfs-docs-icon">
            <Cpu size={32} />
          </div>
          <div>
            <h1>GFS V2 API Documentation</h1>
            <p>Tesseract-Qwen VL Pipeline with Auto Form Detection</p>
          </div>
        </div>
        <a 
          href={getDocsUrl()} 
          target="_blank" 
          rel="noopener noreferrer"
          className="gfs-docs-external-btn"
        >
          <ExternalLink size={18} />
          Open in New Tab
        </a>
      </div>

      {/* Info Cards */}
      <div className="gfs-docs-info-grid">
        <div className="gfs-docs-info-card v2">
          <h3><Cpu size={18} /> Pipeline Details</h3>
          <ul>
            <li><strong>OCR Engine:</strong> Tesseract OCR</li>
            <li><strong>Extraction Model:</strong> Qwen VL (via Bedrock)</li>
            <li><strong>Form Type:</strong> Auto-detected (optional)</li>
            <li><strong>Endpoint:</strong> POST /api/extraction/gfs/v2</li>
          </ul>
        </div>

        <div className="gfs-docs-info-card v2">
          <h3><Zap size={18} /> V2 Features</h3>
          <ul>
            <li><strong>Auto Form Detection:</strong> Uses Tesseract OCR</li>
            <li><strong>Image Preprocessing:</strong> Removes underlines/ticks</li>
            <li><strong>Vision Model:</strong> Qwen VL for better accuracy</li>
            <li><strong>No Manual Selection:</strong> Form type optional</li>
          </ul>
        </div>

        <div className="gfs-docs-info-card api-key-card">
          <h3>Your API Key</h3>
          <div className="gfs-docs-api-key-row">
            <code>{getApiKeyFromStorage() || "Not available - please log in"}</code>
            <button onClick={copyApiKey} disabled={!getApiKeyFromStorage()}>
              {copied ? <CheckCircle size={16} /> : <Copy size={16} />}
              {copied ? "Copied!" : "Copy"}
            </button>
          </div>
        </div>
      </div>

      {/* Swagger Iframe */}
      <div className="gfs-docs-iframe-container">
        <iframe
          src={getDocsUrl()}
          title="GFS V2 Swagger Documentation"
          className="gfs-docs-iframe"
        />
      </div>
    </div>
  );
};

export default GFSV2Docs;
